/* eslint-disable camelcase */
import { config } from '@abyss/ui/tools/config';
import { useQuery } from '../../tools/useQuery';
import { toTitleCase, mpinFormatter } from '../../common/helpers';

const url = `${config('PES_LOCATION_V5_SEARCH')}`;

export const parseResult = result => {
  const initialState = {};
  let providerData = {};

  if (result && result.records) {
    providerData = result.records.map(record => {
      const servicingProviderFirstName =
        record.PTAData.provider?.[0]?.fst_nm || '';
      const servicingProviderLastName =
        record.PTAData.provider?.[0]?.lst_nm || '';

      let servicingProviderName = '';
      if (!servicingProviderFirstName) {
        servicingProviderName = servicingProviderLastName;
      } else {
        servicingProviderName = `${servicingProviderLastName}, ${servicingProviderFirstName}`;
      }

      const corporateProviderFirstName =
        record.PTAData.tax_id?.[0]?.corp_ownr_fst_nm || '';
      const corporateProviderLastName =
        record.PTAData.tax_id?.[0]?.corp_ownr_lst_nm || '';

      let corporateProviderName = '';
      if (!corporateProviderFirstName) {
        corporateProviderName = corporateProviderLastName;
      } else {
        corporateProviderName = `${corporateProviderLastName}, ${corporateProviderFirstName}`;
      }

      let npi = '-';
      if (Array.isArray(record.PTAData.npi?.[0])) {
        const npiId = record.PTAData.npi?.[0][0]?.npi_id?.trim();
        npi = npiId === '' ? '-' : npiId;
      } else {
        const npiId = record.PTAData.npi?.[0]?.npi_id?.trim();
        npi = npiId === '' ? '-' : npiId;
      }

      const taxIdNumber = record.PTAData?.tax_id_nbr || '';

      const corporateProviderMpin =
        record.PTAData.tax_id?.[0]?.corp_ownr_prov_id || '';

      const servicingProviderMpin = record.PTAData?.prov_id || '';

      return {
        servicingProviderFirstName: toTitleCase(servicingProviderFirstName),
        servicingProviderLastName: toTitleCase(servicingProviderLastName),
        servicingProviderName: toTitleCase(servicingProviderName) || '-',
        servicingProviderMpin: mpinFormatter(servicingProviderMpin),
        corporateProviderMpin: mpinFormatter(corporateProviderMpin) || '-',
        corporateProviderLastName: toTitleCase(corporateProviderLastName),
        corporateProviderName: toTitleCase(corporateProviderName),
        npi: npi || '-',
        taxIdNumber,
      };
    });

    return {
      providerData,
      total: result.metadata.total || 0,
    };
  }
  return initialState;
};

export const usePesLocationSearch = options => {
  const queryOptions = {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(options && options.headers),
    },
    onCompleted: result => {
      if (options && options.onCompleted) {
        options.onCompleted(parseResult(result.body));
      }
    },
  };

  const [queryResult, queryAction] = useQuery(url, queryOptions);

  const getPesLocations = ({ taxIdNbr, start, count }) => {
    const urlencoded = new URLSearchParams();
    urlencoded.append('tax-id-nbr', taxIdNbr);
    urlencoded.append('app-nm', 'mpp');
    urlencoded.append('start', start || 0);
    urlencoded.append('count', count || 10);

    return queryAction({ variables: urlencoded });
  };

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, getPesLocations];
};
